import PropTypes from 'prop-types';
import * as util from '#packages/util';
import * as textControls from '#packages/textControls';
import experiment from 'experiment';
import * as invisibleTextEditorMapper from './invisibleTextEditorMapper';
import React from 'react';
import {
  type LinksManagerType,
  TextEditor,
  type TextManager,
} from '@wix/wix-richtext';

import type { DocumentServicesObject } from '@wix/document-services-types';

const {
  connect,
  renderWhenMutated,
  STORES: { EDITOR_API },
} = util.hoc;

export interface InvisibleTextEditorProps {
  loadTextEditingAPI: FunctionFixMe;
  unloadTextEditingAPI: FunctionFixMe;
  loadLinksHelper: FunctionFixMe;
  unloadLinksHelper: FunctionFixMe;
  getFonts: FunctionFixMe;
  documentServices: DocumentServicesObject;
}

class InvisibleTextEditor extends React.Component<InvisibleTextEditorProps> {
  static propTypes = {
    loadTextEditingAPI: PropTypes.func.isRequired,
    unloadTextEditingAPI: PropTypes.func.isRequired,
    loadLinksHelper: PropTypes.func.isRequired,
    unloadLinksHelper: PropTypes.func.isRequired,
    documentServices: PropTypes.object.isRequired,
  };
  static displayName = 'invisibleTextEditor';
  private linksManager: LinksManagerType;
  private stylesManager: AnyFixMe;

  setReady = (manager: TextManager) => {
    this.props.loadTextEditingAPI(manager);
  };

  componentWillUnmount() {
    this.props.unloadLinksHelper();
    this.props.unloadTextEditingAPI();
  }

  UNSAFE_componentWillMount() {
    const linksHelper = new textControls.LinksHelper([]);
    this.props.loadLinksHelper(linksHelper);
    this.linksManager = new textControls.LinksManager(linksHelper);

    this.stylesManager = {
      getFonts: this.props.getFonts,
    };
  }

  getStyleManager = () => {
    return this.stylesManager;
  };

  getLinksManager = () => {
    return this.linksManager;
  };

  render() {
    return (
      <div
        style={{
          visibility: 'hidden',
        }}
      >
        <TextEditor
          initialData="<p></p>"
          onReady={this.setReady}
          validateHtml={false}
          showToolbar={false}
          stylesManager={this.getStyleManager()}
          linksManager={this.getLinksManager()}
          shouldInjectFontsToDocument={false}
          isExperimentOpen={experiment.isOpen}
          documentServicesApi={this.props.documentServices}
        />
      </div>
    );
  }
}

const ConnectedComponent = connect(
  EDITOR_API,
  invisibleTextEditorMapper.mapStateToProps,
  invisibleTextEditorMapper.mapDispatchToProps,
)(renderWhenMutated(InvisibleTextEditor));

ConnectedComponent.pure = InvisibleTextEditor;

export default ConnectedComponent;
